/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_firstlogin = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		$(document).on('input','input',function() {

			/*
			Background color
			*/
			$(this).css({
				'background-color' : '#fff'
			});

			/*
			Telephone
			*/
			_dialCode 		= iti.getSelectedCountryData().dialCode;
			_phoneNumber 	= $('.js-form-input-telephone_iti').val();
			_resetNumber 	= '+' + _dialCode + _phoneNumber;

			$('.js-form-input-telephone').val(_resetNumber);

		});

		if($('.js-form-input-firstname').val() == '') {
			$('.js-form-input-firstname').css({
				'background-color' : '#FFECC5'
			});
		}
		if($('.js-form-input-lastname').val() == '') {
			$('.js-form-input-lastname').css({
				'background-color' : '#FFECC5'
			});
		}
		if($('.js-form-input-street').val() == '') {
			$('.js-form-input-street').css({
				'background-color' : '#FFECC5'
			});
		}
		if($('.js-form-input-zipcode').val() == '') {
			$('.js-form-input-zipcode').css({
				'background-color' : '#FFECC5'
			});
		}
		if($('.js-form-input-city').val() == '') {
			$('.js-form-input-city').css({
				'background-color' : '#FFECC5'
			});
		}
		if($('.js-form-input-email').val() == '') {
			$('.js-form-input-email').css({
				'background-color' : '#FFECC5'
			});
		}
		if (
			$('.js-form-input-telephone').val() == '' ||
			(
				$('.js-form-input-telephone').val() == '' &&
				$('.js-form-input-telephone').val().length <= 6
			)
		) {
			$('.js-form-input-telephone_iti').css({
				'background-color': '#FFECC5'
			});
		}
		if($('.js-form-input-birthdate').val() == '') {
			$('.js-form-input-birthdate').css({
				'background-color' : '#FFECC5'
			});
		}

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none
			
}).apply(specific_firstlogin); 